import { RoleItemProps } from "apis";
import { lazy } from "react";

export const PageAdminRole = lazy(() => import("./List"));
export const PageAdminRoleCreate = lazy(() => import("./Add"));
export const PageAdminRoleUpdate = lazy(() => import("./Edit"));

export interface FormRoleValuesProps extends RoleItemProps { }